import { render, staticRenderFns } from "./ItemAdminGeneral.vue?vue&type=template&id=247ece5b&scoped=true&"
import script from "./ItemAdminGeneral.vue?vue&type=script&lang=js&"
export * from "./ItemAdminGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ItemAdminGeneral.vue?vue&type=style&index=0&id=247ece5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247ece5b",
  null
  
)

export default component.exports